module.exports = __webpack_public_path__ + "../resources/images/illustration_access_error-bd21e90cefc8a7f1f931c0bff0fafc32.svg";